export default __webpack_public_path__ + "static/media/hippo.536ebd52.ogg";